import { Grid, Typography } from "@mui/material";
import { PieChart } from "@mui/x-charts";
import { useMemo } from "react";

const CurrentAllocationChartReport = ({ value }: { value: number }) => {
  const data = useMemo(
    () => [
      { id: "Stock", value: value, color: "#00416a" },
      { id: "Option", value: 100 - value, color: "#dec9a4" },
    ],
    [value],
  );

  const settings = {
    margin: { right: 5 },
    width: 100,
    height: 100,
    hideLegend: true,
  };
  return (
    <Grid container spacing={2}>
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          width: "50%",
        }}
      >
        <Typography
          variant="h6"
          sx={{ color: (theme) => theme.palette.primary.dark }}
        >
          Current Allocation
        </Typography>
      </Grid>
      <Grid item xs={12} md={6}>
        <PieChart
          series={[{ innerRadius: 20, outerRadius: 40, data: data }]}
          {...settings}
        />
      </Grid>
    </Grid>
  );
};

export default CurrentAllocationChartReport;
